var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.47956 0 0 .49609 -.96909 -.96909)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.061 0 0 1.1111 -.97613 -3.4222)",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 29h-16a3 3 0 0 1-3-3v-10a1 1 0 0 1 2 0v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-10a1 1 0 0 1 2 0v10a3 3 0 0 1-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 29h-5a1 1 0 0 1-1-1v-6a3 3 0 0 1 3-3h1a3 3 0 0 1 3 3v6a1 1 0 0 1-1 1zm-4-2h3v-5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 17a4 4 0 0 1-4-4 1 1 0 0 1 2 0 2 2 0 0 0 4 0v-0.76l-2.62-5.24h-16.76l-2.62 5.24v0.76a2 2 0 0 0 4 0 1 1 0 0 1 2 0 4 4 0 0 1-8 0v-1a1 1 0 0 1 0.11-0.45l3-6a1 1 0 0 1 0.89-0.55h18a1 1 0 0 1 0.89 0.55l3 6a1 1 0 0 1 0.11 0.45v1a4 4 0 0 1-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 17a4 4 0 0 1-4-4 1 1 0 0 1 2 0 2 2 0 0 0 4 0 1 1 0 0 1 2 0 4 4 0 0 1-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 17a4 4 0 0 1-4-4 1 1 0 0 1 2 0 2 2 0 0 0 4 0 1 1 0 0 1 2 0 4 4 0 0 1-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 22h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "frame",
    transform: "matrix(.86207 0 0 .83333 2.2069 2.1333)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.cd6390caca9a33e002548aac4387983d.svg";
export { ForwardRef as ReactComponent };